export enum ESocketEventName {
  orderInvalidateOne = 'order.invalidateOne',
  orderInvalidateMany = 'order.invalidateMany',
  cargoInvalidateOne = 'cargo.invalidateOne',
  tripInvalidateOne = 'trip.invalidateOne',
  cargoTripInvalidateMany = 'cargoTrip.invalidateMany',
  invoiceSyncStatusUpdated = 'invoice.syncStatusUpdated',
}

export interface IOrderInvalidateManyEvent {
  payload: {
    orderIds: number[];
  };
}

export interface IOrderInvalidateOneEvent {
  payload: {
    orderId: number;
  };
}

export interface ICargoInvalidateOneEvent {
  payload: {
    cargoId: number;
  };
}

export interface ITripInvalidateOneEvent {
  payload: {
    tripId: number;
  };
}

export interface ICargoTripInvalidateManyEvent {
  payload: {
    tripId: number;
  };
}

export interface IInvoiceSyncStatusUpdateEvent {
  payload: {
    invoiceId: number;
  };
}
